import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#0456A4',
          secondary: '#033e75',
          success: '#22c55e',
          error: '#ef4444',
          warning: '#f59e0b',
        }
      }
    }
  }
})

createApp(App).use(router).use(vuetify).mount('#app')